import type { TokenStore } from "@its-engineering-and-development/jwt-auth-client";
import { authSiteName } from "@app/lib/auth/auth-config";

const keyPrefix = `ea.${authSiteName ?? "default"}`;

export const authAccessTokenKey = `${keyPrefix}.at`;
export const authRefreshTokenKey = `${keyPrefix}.rt`;
export const authAccessTokenChangedEvent =
  "events-admin:auth-access-token-changed";

// Retained for backward compatibility with existing tests.
export const AUTH_ACCESS_TOKEN_KEY = authAccessTokenKey;

function dispatchAccessTokenChanged(token: string | null): void {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(authAccessTokenChangedEvent, {
      detail: { token },
    }),
  );
}

class BrowserTokenStore implements TokenStore {
  getAccessToken(): string | null {
    if (typeof window === "undefined") {
      return null;
    }

    return window.localStorage.getItem(authAccessTokenKey);
  }

  setAccessToken(token: string): void {
    if (typeof window === "undefined") {
      return;
    }

    window.localStorage.setItem(authAccessTokenKey, token);
    dispatchAccessTokenChanged(token);
  }

  getRefreshToken(): string | null {
    if (typeof window === "undefined") {
      return null;
    }

    return window.localStorage.getItem(authRefreshTokenKey);
  }

  setRefreshToken(token: string): void {
    if (typeof window === "undefined") {
      return;
    }

    window.localStorage.setItem(authRefreshTokenKey, token);
  }

  clear(): void {
    if (typeof window === "undefined") {
      return;
    }

    window.localStorage.removeItem(authAccessTokenKey);
    window.localStorage.removeItem(authRefreshTokenKey);
    dispatchAccessTokenChanged(null);
  }
}

export const authTokenStore = new BrowserTokenStore();
